import { STRINGS } from 'config';

const consultation = STRINGS.CONSULTATION_REDUCER;

export const mockFindAddresses = postcode => dispatch => {
  dispatch({ type: 'consultation/MOCK_FIND_ADDRESSES_REQUEST', payload: postcode });
  dispatch({
    type: consultation.FIND_ADDRESSES_SUCCESS,
    payload: ([
      '12 Test Street, , , , Test Borough, Test City,',
      '34 Mock Mews, , , , Mock Borough, Mock City,',
      '56 Fake Road, , , , , Fake City,',
      'Mc Imagined Services Ltd, 78B Imagined Road, , , , Imagined City,',
    ]),
  });
};
